export const CURRENT_TASKS = "CURRENT_TASKS";
export const DELETE_TASK = "DELETE_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const ADD_TASK = "ADD_TASK";
export const UPDATE_CURRENT_TAB = "UPDATE_CURRENT_TAB"